import { Component, OnInit } from "@angular/core";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import * as moment from "moment";
import { wholeAmountFormatter } from "../custompipes/amount-formatter";

@Component({
  selector: "app-offramp-balance",
  templateUrl: "./offramp-balance.component.html",
  styleUrls: ["./offramp-balance.component.css"],
})
export class OfframpBalanceComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };

  balances: any[] = [];
  // Rows with a balance refresh in flight, keyed by Provider_MId
  refreshingRows = new Set<string>();

  constructor(
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: "Action",
        field: "action",
        cellRenderer: (params) => {
          const row = params.data;
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "btn btn-sm btn-primary";
          btn.title = "Fetch latest balance from gateway";
          btn.innerHTML = '<i class="fa fa-refresh"></i>';
          btn.disabled = !row.MId || this.refreshingRows.has(this.getRowKey(row));
          btn.onclick = (e) => {
            e.stopPropagation();
            this.refreshRowBalance(row);
          };
          return btn;
        },
        sortable: false,
        filter: false,
        flex: 0.5,
        minWidth: 80,
      },
      { headerName: "Provider", field: "Provider", flex: 1 },
      { headerName: "Name", field: "Name", flex: 1.5 },
      { headerName: "MID", field: "MId", flex: 1.5 },
      {
        headerName: "Balance",
        field: "Balance",
        flex: 1,
        valueFormatter: (params) => wholeAmountFormatter(params) || "-",
      },
      {
        headerName: "UpdatedAt",
        field: "UpdatedAt",
        flex: 1.5,
        valueFormatter: (params) => {
          return params.value
            ? moment(Number(params.value)).format("MMM DD, YYYY hh:mm:ss A")
            : "-";
        },
      },
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  getData() {
    this.spinnerService.show();
    this.offrampService.getOfframpBalances().subscribe(
      (list: any) => {
        this.balances = list || [];
        this.rowData = this.balances;
        if (this.gridApi) {
          this.gridApi.setRowData(this.rowData);
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.notifSer.error("Error", "Failed to fetch offramp balances", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.spinnerService.hide();
      }
    );
  }

  refresh() {
    this.getData();
  }

  private getRowKey(row: any): string {
    return `${row.Provider}_${row.MId}`;
  }

  refreshRowBalance(row: any) {
    const rowKey = this.getRowKey(row);
    if (this.refreshingRows.has(rowKey)) {
      return;
    }
    this.refreshingRows.add(rowKey);
    if (this.gridApi) {
      this.gridApi.redrawRows();
    }

    const done = () => {
      this.refreshingRows.delete(rowKey);
      this.getData();
    };

    this.offrampService.refreshOfframpBalance({ _csrf: this._csrf, Provider: row.Provider, MId: row.MId }).subscribe(
      () => {
        // The processor fetches the balance from the gateway asynchronously, give it a moment before reloading
        setTimeout(done, 3000);
      },
      (error) => {
        this.notifSer.error("Error", (error && error.error && error.error.message) || "Failed to refresh balance", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        done();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-balance/offramp-balance.component.ts